"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_mail_favorites_store_1 = require("owa-mail-favorites-store");
function getFavoritePersonaByEmail(emailAddress) {
    var personas = owa_mail_favorites_store_1.favoritesStore.favoritesPersonaNodes
        .values()
        .filter(function (node) {
        return node.mainEmailAddress &&
            node.mainEmailAddress.toLowerCase() === emailAddress.toLowerCase();
    });
    if (personas && personas.length > 0) {
        return personas[0];
    }
    return undefined;
}
exports.default = getFavoritePersonaByEmail;
//# sourceMappingURL=getFavoritePersonaByEmail.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-favorites-store/lib/selectors/getFavoritePersonaByEmail.js
// module id = 4653
// module chunks = 14